import ChatMessage from './ChatMessage';

class AssistantMessage extends ChatMessage {
  constructor(message = '') {
    super('assistant', message);
  }
}

export default AssistantMessage;
